import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { IonContent, AlertController } from '@ionic/angular';  // renamed from Content

import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/services/global/global.service';
import { ConnectivityService } from 'src/app/services/connectivity/connectivity.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { MonitoringService } from 'src/app/services/monitoring/monitoring.service';
import { GeolocationWrapperService } from 'src/app/services/geolocation/geolocation.service';
import { Subscription } from 'rxjs';
import { GeoPosition, GeoStatus } from 'src/app/services/geolocation/geoposition';
import { NotificationData, ConnectivityData } from 'src/app/services/global/structure';

// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service';  // workaround for events

/**
 * Contains header displays for various subscriptions:  Connectivity, Monitoring, Geolocation, etc.
 */

@Component({
  selector: 'mystatus',
  templateUrl: './mystatus.component.html',
  styleUrls: ['./mystatus.component.scss'],
})
export class MystatusComponent implements OnInit, OnDestroy  {

  @ViewChild(IonContent) content: IonContent;   
  // https://toddmotto.com/component-events-event-emitter-output-angular-2
  @Input() pageName:string; //@Input('pageName') pageName;
  //@Output() outIsGpsWatching: EventEmitter<boolean> = new EventEmitter<boolean>();
  //@Output() outGpsStatus: EventEmitter<GeoStatus> = new EventEmitter<GeoStatus>();
  //@Output() outGpsPosition: EventEmitter<GeoPosition> = new EventEmitter<GeoPosition>();
  //@Output() outIpsStatus: EventEmitter<GeoStatus> = new EventEmitter<GeoStatus>();
  //@Output() outIpsPosition: EventEmitter<GeoPosition> = new EventEmitter<GeoPosition>();
  @Output() outMonitorApiResponse: EventEmitter<any> = new EventEmitter<any>();

  consoleLog:boolean = false;

  //private SubscribedPages: string[] = [];
  private SubscribedPages = new Array<string>();

  // Subscription: Geolocation - Gps Position
  //private GpsSubscription: Subscription;
  public GpsPosition:GeoPosition = new GeoPosition();
  public GpsStatus:GeoStatus = new GeoStatus();
  public isGpsWatching:boolean;
  
  // Subscription: Geolocation - Ips Position
  //private IpsSubscription: Subscription;
  public IpsPosition:GeoPosition = new GeoPosition();
  public IpsStatus:GeoStatus = new GeoStatus();
  public isIpsWatching:boolean;

  // Subscription: network connectivity 
  //private connectivitySubscription: Subscription;
  public isOnline:boolean = true;
  public connectivityData:ConnectivityData;

  // Subscription: Notification 
  public isNotification:boolean = false;
  private notificationData:NotificationData;

  // Subscription: Monitoring 
  private monitoringSubscription: Subscription;
  public isMonitoring:boolean = false;
  public MonitorStatus:string = "";

  // Subscription: Countdown for Monitoring
  private monitorCountdownSubscription: Subscription;
  public isMonitorTimerOn:boolean = false;
  public MonitorCountdownCurrent:number = 0;
  public MobileMonitorUpdatesCount:number = 0;
  public MobileMonitorUpdatesCount_Prev:number = 0;

  // // display options
  // public isDisplayGpsStatus:boolean = false;  
  // public isDisplayIpsStatus:boolean = false; 
  // public isDisplayMonitorStatus:boolean = false; 
  // public isDisplayOnlineStatus:boolean = true;  
  
  // specific screen overrides
  public isMapGpsOverride:boolean = false; 
  public isMapIpsOverride:boolean = false; 

  // subscriptions
  public isSubscribeConnectivity:boolean = false;
  public isSubscribeNotification:boolean = false;
  public isSubscribeMonitoring:boolean = false;
  public isSubscribeMonitorCountdown:boolean = false;
  public isSubscribeGpsStatus:boolean = false;
  public isSubscribeIpsStatus:boolean = false;
  //    this.isSubscribeConnectivity = isSubscribe;

  // API information that the parent page may be interested in
  //private MonitorApiResponse:any;  // use this to emit the API info for display on the Monitor screen

  constructor(
      private alertController: AlertController
    , private connectivityProvider: ConnectivityService
    , private notificationProvider: NotificationService
    , private monitoringProvider: MonitoringService
    , private geolocationProvider: GeolocationWrapperService
    , public globalProvider: GlobalService
    , public events: Events
    , public zone: NgZone 
    , public translate: TranslateService
    // public navCtrl: NavController, public navParams: NavParams
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_mystatus;
    //if (this.consoleLog) 
    console.log('mystatus.ctor - LifeCycle');
  }

  // ----------------------------------------------------
  // -------- COMPONENT LIFE-CYCLE EVENTS  --------------
  // ----------------------------------------------------
  ngOnInit() //  ngAfterViewInit()
  {
    if (this.consoleLog) console.log('mystatus.ngOnInit - LifeCycle - Page:' + this.pageName);
    this.Initialize("ngOnInit");
  }

  // this IS called -- just before the component is removed
  ngOnDestroy() 
  { 
    //alert("mystatus.ngOnDestroy - LifeCycle");
    if (this.consoleLog) console.log('mystatus.ngOnDestroy - LifeCycle - Page:' + this.pageName);
    this.subscriptions(false, "mystatus.ngOnDestroy - LifeCycle");
  }

  // ----------------------------------------------------
  // ------ PAGE LIFE-CYCLE EVENTS (Ionic)  -------------
  // ----------------------------------------------------
  // NOT INVOKED INSIDE COMPONENTS??
  // NOT INVOKED INSIDE COMPONENTS??
  // NOT INVOKED INSIDE COMPONENTS??
  ionViewWillEnter() {  if (this.consoleLog) console.log("mystatus.ionViewWillEnter - LifeCycle"); }
  ionViewWillLeave() {  if (this.consoleLog) console.log("mystatus.ionViewWillLeave - LifeCycle"); }
  ionViewDidLeave()  {  if (this.consoleLog) console.log("mystatus.ionViewDidLeave - LifeCycle"); }
  ionViewDidEnter()  {  if (this.consoleLog) console.log('mystatus.ionViewDidEnter - LifeCycle'); }
  // NOT INVOKED INSIDE COMPONENTS??
  // NOT INVOKED INSIDE COMPONENTS??
  // NOT INVOKED INSIDE COMPONENTS??


  // ----------------------------------------------------
  // ---------------     INITIALIZE      ----------------
  // ----------------------------------------------------

  public Initialize(context:string)
  {
    if (this.consoleLog) console.log('mystatus.Initialize - LifeCycle - Page:' + this.pageName);
    this.setDisplayOptions();
    this.subscriptions(true, "mystatus.Initialize-" + this.pageName);
  }

  setDisplayOptions()
  {
    if (!this.globalProvider) { return; }
    if (!this.globalProvider.HeaderDisplay) { return; }
    // these are default settings, but the display can be overridden if there is something to show

    this.zone.run(() => {
      if (this.connectivityProvider)
      {
        this.isOnline = this.connectivityProvider.IsOnline();  // get initial state
        this.connectivityData = this.connectivityProvider.GetConnectivityData();
      }
  
      if (this.consoleLog) console.log("mystatus.setDisplayOptions Page:" + this.pageName, this.globalProvider.HeaderDisplay);
      // if (this.content) { this.content.resize(); }
    });
  }

  // ----------------------------------------------------
  // ------ FUNCTIONS AVAILABLE TO PARENT PAGE  ---------
  // ----------------------------------------------------
  // function that can be called from the parent page via the following HTML syntax:
  /*
        
  <!-- need to wrap the header status in a div otherwise it won't display -->
  <div><mystatus [pageName]="pageName" #mystatus></mystatus></div>
  
        <button (click)='mystatus.CallMe("Actions")'>CLICK ME</button>
  */
  public CallMe(context:string)
  {
    console.log('mystatus.CallMe: ' + context + ' - Page:' + this.pageName);
  }


  // ----------------------------------------------------
  // ---------------      SUBSCRIPTIONS       -----------
  // ----------------------------------------------------
  subscriptions(isSubscribe:boolean, context:string)
  {
    if (this.consoleLog) console.log('mystatus.Subscriptions: ' + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName + " " + context);
    
    // TEST CODE
    // if ( (isSubscribe == true) && (this.isAlreadySubscribed()) ) { return; } 
    let subscribeValue = (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE");
    this.DisplaySubscriptions("BEFORE-" + subscribeValue);
    let pageResult:boolean = this.MaintainSubscribedPages(isSubscribe);
    if (!pageResult)
    {
      console.warn('mystatus.Subscriptions - SUBSCRIPTION WARNING - isSubscribe: ' + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName + " " + context);
      return;
    }
    
    this.SubscribeToConnectivity(isSubscribe);
    this.SubscribeToNotification(isSubscribe);
    this.SubscribeToGpsStatus(isSubscribe);
    this.SubscribeToIpsStatus(isSubscribe);
    this.SubscribeToMonitorCountdown(isSubscribe);   // make this optional and configurable
    this.SubscribeToMonitoring(isSubscribe);

    this.DisplaySubscriptions("AFTER-" + subscribeValue);
  }

  DisplaySubscriptions(context:string)
  {
    if (!this.consoleLog) { return; }

    let subscriptionStates 
      = " Connectivity:" + this.isSubscribeConnectivity
      + " Notification:" + this.isSubscribeNotification
      + " Monitoring:" + this.isSubscribeMonitoring
      + " MonitorCountdown:" + this.isSubscribeMonitorCountdown
      + " GpsStatus:" + this.isSubscribeGpsStatus
      + " IpsStatus:" + this.isSubscribeIpsStatus
      ;

    console.log("mystatus.DisplaySubscriptions(" + context + ") - Page:" + this.pageName + " ..." + subscriptionStates);
  }

  MaintainSubscribedPages(isSubscribe:boolean):boolean
  {
    if (!this.pageName)
    {
      console.error("mystatus.MaintainSubscribedPages is missing PageName", this.SubscribedPages);
      return false;
    }

    if ( !this.SubscribedPages )
    {
      console.error("mystatus.MaintainSubscribedPages missing array", this.SubscribedPages);
      return false;
    }

    if (isSubscribe)
    {
      if ( this.SubscribedPages.indexOf(this.pageName) < 0)
      {
        this.SubscribedPages.push(this.pageName);
        if (this.consoleLog) console.log("mystatus.MaintainSubscribedPages - isSubscribe:" + isSubscribe + " ADDED:" + this.pageName + " Total:" + this.SubscribedPages.length, this.SubscribedPages);
        return true;
      }
      else
      {
        if (this.consoleLog) console.warn("mystatus.MaintainSubscribedPages - isSubscribe:" + isSubscribe + " ALREADY_EXISTS:" + this.pageName + " Total:" + this.SubscribedPages.length, this.SubscribedPages);
        return false;
      }
    }
    else
    {
      if ( this.SubscribedPages.indexOf(this.pageName) < 0)
      {
        if (this.consoleLog) console.warn("mystatus.MaintainSubscribedPages - isSubscribe:" + isSubscribe + " ALREADY_REMOVED:" + this.pageName + " Total:" + this.SubscribedPages.length, this.SubscribedPages);
        return false;
      }
      else
      {
        this.SubscribedPages.splice(this.SubscribedPages.indexOf(this.pageName));
        if (this.consoleLog) console.log("mystatus.MaintainSubscribedPages - isSubscribe:" + isSubscribe + " REMOVED:" + this.pageName + " Total:" + this.SubscribedPages.length, this.SubscribedPages);
        return true;
      }
    }
  }

  /* OLD OBSERVABLE APPROACH
  // ----------------------------------------------------
  // --------------- NETWORK CONTROLLER WATCH -----------
  // ----------------------------------------------------
  SubscribeToConnectivity(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.Connectivity: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    if (isSubscribe)
    {
      this.isOnline = this.connectivityProvider.IsOnline();  // get initial state

      //if (this.consoleLog) console.log("mystatus.Connectivity SUBSCRIBE");
      this.connectivitySubscription = this.connectivityProvider.connection.subscribe((isOnline) => {
        this.isOnline = isOnline;
        if (this.consoleLog) console.log("mystatus.Connectivity CHANGED TO " + (isOnline ? "ONLINE" : "OFFLINE") + " - Page:" + this.pageName );
        //if (this._isInitialized == false) { this.Initialize("ctor"); }
      });
    }
    else
    {
      //if (this.consoleLog) console.log("mystatus.Connectivity UNSUBSCRIBE");
      this.connectivitySubscription.unsubscribe();
    }
  }
  */


  // ----------------------------------------------------
  // ---------- Connectivity CONTROLLER WATCH -----------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _ConnectivityEventSub: (connectivityData:ConnectivityData) => void;

  DefineConnectivityEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mystatus.DefineConnectivityEventSub" + ' - Page:' + this.pageName);
    this._ConnectivityEventSub = (connectivityData:ConnectivityData) => {
      this.onConnectivity(connectivityData);
    };
  }

  public isActiveSubscriptionConnectivity: boolean = false;
  SubscribeToConnectivity(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.Connectivity: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    this.isOnline = this.connectivityProvider.IsOnline();  // get initial state
    this.connectivityData = this.connectivityProvider.GetConnectivityData();
    if (this.consoleLog) console.log("mystatus.Connectivity: " + (this.isOnline ? "ONLINE" : "OFFLINE") + ' - Page:' + this.pageName, this.connectivityData);

    //this.isConnectivity = this.ConnectivityProvider.IsConnectivity();  // get initial/latest state
    this.isSubscribeConnectivity = isSubscribe;
    if (isSubscribe)
    {
      if (this.isActiveSubscriptionConnectivity === true)
      {
        if (this.consoleLog) console.log("mystatus.Connectivity - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionConnectivity = true;
      this.DefineConnectivityEventSub();
      this.events.subscribe('mystatus' + this.pageName, 'connectivityData', this._ConnectivityEventSub); 
    }
    else
    {
      if (this.consoleLog) console.log("mystatus.Connectivity: ATTEMPT UNSUBSCRIBE" + ' - Page:' + this.pageName);
      this.events.unsubscribe('mystatus' + this.pageName, 'connectivityData', this._ConnectivityEventSub); 
      this.isActiveSubscriptionConnectivity = false;
    }
  }

  onConnectivity(data:any) // (connectivityData:ConnectivityData)
  {
    if (this.consoleLog) console.log("mystatus.onConnectivity" + ' - Page:' + this.pageName, data);
    this.zone.run(() => {
      //this.connectivityData = data.connectivityData; // NOTE!!!  I think the object is within the data wrapper
      this.connectivityData = this.connectivityProvider.GetConnectivityData();
      this.isOnline = this.connectivityProvider.IsOnline();  // get state
      if (this.consoleLog) console.log("mystatus.onConnectivity: " + (this.isOnline ? "ONLINE" : "OFFLINE") + ' - Page:' + this.pageName);

    //this.isConnectivity = this.ConnectivityProvider.IsConnectivity();
    });
  }


  // ----------------------------------------------------
  // ---------- NOTIFICATION CONTROLLER WATCH -----------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _NotificationEventSub: (notificationData:NotificationData) => void;

  DefineNotificationEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mystatus.DefineNotificationEventSub" + ' - Page:' + this.pageName);
    this._NotificationEventSub = (notificationData:NotificationData) => {
      this.onNotification(notificationData);
    };
  }

  public isActiveSubscriptionNotification:boolean = false;
  SubscribeToNotification(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.Notification: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    this.isNotification = this.notificationProvider.IsNotification();  // get initial/latest state
    this.isSubscribeNotification = isSubscribe;
    if (isSubscribe)
    {
      if (this.isActiveSubscriptionNotification === true)
      {
        if (this.consoleLog) console.log("mystatus.Notification - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionNotification = true;
      this.DefineNotificationEventSub();
      this.events.subscribe('mystatus' + this.pageName, 'isNotification', this._NotificationEventSub); 
    }
    else
    {
      if (this.consoleLog) console.log("mystatus.Notification: ATTEMPT UNSUBSCRIBE" + ' - Page:' + this.pageName);
      this.events.unsubscribe('mystatus' + this.pageName, 'isNotification', this._NotificationEventSub); 
      this.isActiveSubscriptionNotification = false;
    }
  }

  onNotification(notificationData:NotificationData)
  {
    if (this.consoleLog) console.log("mystatus.onNotification" + ' - Page:' + this.pageName, notificationData);
    this.zone.run(() => {
      this.notificationData = notificationData;
      this.isNotification = this.notificationProvider.IsNotification();
    });
  }
  

  // ----------------------------------------------------
  // --------------- LOCATION CONTROLLER WATCH ----------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _GpsEventSub: (geoStatus:GeoStatus) => void;
  DefineGpsEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mystatus.DefineGpsEventSub" + ' - Page:' + this.pageName);
    this._GpsEventSub = (geoStatus:GeoStatus) => {
      this.onGpsStatus(geoStatus);
    };
  }

  private _GpsPositionEventSub: (geoPosition:GeoPosition) => void;
  DefineGpsPositionEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mystatus._GpsPositionEventSub" + ' - Page:' + this.pageName);
    this._GpsPositionEventSub = (geoPosition:GeoPosition) => {
      this.onGpsResponse(geoPosition);
    };
  }

  public isActiveSubscriptionGpsStatus:boolean = false;
  SubscribeToGpsStatus(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.GPS: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    this.isSubscribeGpsStatus = isSubscribe;
    if (isSubscribe)
    {
      this.GpsStatus = this.geolocationProvider.GetGpsStatus();  // get initial status
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();

      this.GpsPosition = this.geolocationProvider.GetGpsPosition();  // get initial position
      this.onGpsResponse(this.GpsPosition);

      if (this.isActiveSubscriptionGpsStatus === true)
      {
        if (this.consoleLog) console.log("mystatus.GPS - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionGpsStatus = true;
      this.DefineGpsEventSub();
      this.events.subscribe('mystatus' + this.pageName, 'geolocation:gpsStatus', this._GpsEventSub);

      this.DefineGpsPositionEventSub();
      this.events.subscribe('mystatus' + this.pageName, 'geolocation:gpsPosition', this._GpsPositionEventSub);
      this.isActiveSubscriptionGpsStatus = false;

      //if (this.consoleLog) console.log("Map.SubscribeToGps SUBSCRIBE");
      //this.GpsSubscription = this.geolocationProvider.gpsObservable.subscribe(
      //  (geoPosition) => { this.onGpsResponse(geoPosition); }
      //, (error)       => { this.onGpsError(error); }
      //);
    }
    else
    {
      //this.GpsSubscription.unsubscribe();
      this.events.unsubscribe('mystatus' + this.pageName, 'geolocation:gpsStatus', this._GpsEventSub);
      this.events.unsubscribe('mystatus' + this.pageName, 'geolocation:gpsPosition', this._GpsPositionEventSub);
    }
  }

  onGpsResponse(geoPosition:GeoPosition) 
  {
    if (this.consoleLog) console.log("mystatus.onGpsResponse" + ' - Page:' + this.pageName, geoPosition);
    this.zone.run(() => {
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      this.GpsPosition = geoPosition;
      //this.outGpsPosition.emit(this.GpsPosition);  // send to parent page
      this.GpsStatus = geoPosition.GeoStatus; // this.geolocationProvider.GetGpsStatus();  
      //this.outGpsStatus.emit(this.GpsStatus);  // send to parent page
      //this.outIsGpsWatching.emit(this.GpsStatus.ActiveWatch);
      // if (this.content) { this.content.resize(); }
    });
  }

  /*
  onGpsError(error:any) 
  {
    console.error("mystatus.onGeolocationError" + ' - ' + this.pageName, error);
    this.zone.run(() => {
      // this should be trapped in the Provider and not here, but let's handle it anyway just in case...
      this.GpsStatus.Success = false;  
      this.GpsStatus.ResultText = "GPS error";  
      this.GpsStatus.ResultCode = "GPS88";  
      if ((error) && (error.message)) { this.GpsStatus.ResultText = error.message; }
      if ((error) && (error.code)) { this.GpsStatus.ResultCode = error.code; }
      this.outGpsStatus.emit(this.GpsStatus);  // send to parent page
      this.outIsGpsWatching.emit(this.GpsStatus.ActiveWatch);
      
      // if (this.content) { this.content.resize(); }
    });
  }
  */

  onGpsStatus(geoStatus:GeoStatus)
  {
    if (this.consoleLog) console.log("mystatus.onGpsStatus" + ' - Page:' + this.pageName, geoStatus);
    this.zone.run(() => {
      this.GpsStatus = geoStatus;
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      //this.outGpsStatus.emit(this.GpsStatus);  // send to parent page
      //this.outIsGpsWatching.emit(this.GpsStatus.ActiveWatch);

      // if (this.content) { this.content.resize(); }
    });
  }

  public RefreshGpsStatus()
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mystatus.RefreshGpsStatus" + ' - Page:' + this.pageName, this.GpsStatus);
    this.zone.run(() => {
      this.GpsStatus = this.geolocationProvider.GetGpsStatus();
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      //this.outGpsStatus.emit(this.GpsStatus);  // send to parent page
      //this.outIsGpsWatching.emit(this.GpsStatus.ActiveWatch);

      // if (this.content) { this.content.resize(); }
    });
  }

  public RefreshGpsPosition()  // onGpsResponse(geoPosition:GeoPosition) 
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mystatus.RefreshGpsPosition" + ' - Page:' + this.pageName);
    this.zone.run(() => {
      this.isGpsWatching = this.geolocationProvider.isGpsWatching();
      this.GpsPosition = this.geolocationProvider.GetGpsPosition();
      //this.outGpsPosition.emit(this.GpsPosition);  // send to parent page
      this.GpsStatus = this.geolocationProvider.GetGpsStatus();
      //this.outGpsStatus.emit(this.GpsStatus);  // send to parent page
      //this.outIsGpsWatching.emit(this.GpsStatus.ActiveWatch);
      // if (this.content) { this.content.resize(); }
    });
  }

  
  // ----------------------------------------------------
  // ----------- IPS LOCATION CONTROLLER WATCH ----------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _IpsEventSub: (geoStatus:GeoStatus) => void;
  DefineIpsEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mystatus.DefineIpsEventSub" + ' - Page:' + this.pageName);
    this._IpsEventSub = (geoStatus:GeoStatus) => {
      this.onIpsStatus(geoStatus);
    };
  }

  private _IpsPositionEventSub: (geoPosition:GeoPosition) => void;
  DefineIpsPositionEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mystatus.DefineIpsPositionEventSub" + ' - Page:' + this.pageName);
    this._IpsPositionEventSub = (geoPosition:GeoPosition) => {
      this.onIpsResponse(geoPosition);
    };
  }

  public isActiveSubscriptionIpsStatus:boolean = false;
  SubscribeToIpsStatus(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.IPS: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    this.isSubscribeIpsStatus= isSubscribe;
    if (isSubscribe)
    {
      this.IpsStatus = this.geolocationProvider.GetIpsStatus();  // get initial status
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();

      this.IpsPosition = this.geolocationProvider.GetIpsPosition();  // get initial position
      this.onIpsResponse(this.IpsPosition);

      if (this.isActiveSubscriptionIpsStatus === true)
      {
        if (this.consoleLog) console.log("mystatus.IPS - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionIpsStatus = true;
      this.DefineIpsEventSub();
      this.events.subscribe('mystatus' + this.pageName, 'geolocation:ipsStatus', this._IpsEventSub);

      this.DefineIpsPositionEventSub();
      this.events.subscribe('mystatus' + this.pageName, 'geolocation:ipsPosition', this._IpsPositionEventSub);
    }
    else
    {
      this.events.unsubscribe('mystatus' + this.pageName, 'geolocation:ipsStatus', this._IpsEventSub);
      this.events.unsubscribe('mystatus' + this.pageName, 'geolocation:ipsPosition', this._IpsPositionEventSub);
      this.isActiveSubscriptionIpsStatus = false;
    }
  }

  onIpsResponse(geoPosition:GeoPosition) 
  {
    if (this.consoleLog) console.log("mystatus.onIpsResponse" + ' - Page:' + this.pageName, geoPosition);
    this.zone.run(() => {
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
      this.IpsPosition = geoPosition;
      //this.outIpsPosition.emit(this.IpsPosition);  // send to parent page
      this.IpsStatus = geoPosition.GeoStatus; // this.geolocationProvider.GetIpsStatus();  
      //this.outIpsStatus.emit(this.IpsStatus);  // send to parent page
      // if (this.content) { this.content.resize(); }
    });
  }

  /*
  onIpsError(error:any) 
  {
    console.error("mystatus.onGeolocationError" + ' - ' + this.pageName, error);
    this.zone.run(() => {
      // this should be trapped in the Provider and not here, but let's handle it anyway just in case...
      this.IpsStatus.Success = false;  
      this.IpsStatus.ResultText = "IPS error";  
      this.IpsStatus.ResultCode = "IPS88";  
      if ((error) && (error.message)) { this.IpsStatus.ResultText = error.message; }
      if ((error) && (error.code)) { this.IpsStatus.ResultCode = error.code; }
      this.outIpsStatus.emit(this.IpsStatus);  // send to parent page
      
      // if (this.content) { this.content.resize(); }
    });
  }
  */

  onIpsStatus(geoStatus:GeoStatus)
  {
    if (this.consoleLog) console.log("mystatus.onIpsStatus" + ' - Page:' + this.pageName, geoStatus);
    this.zone.run(() => {
      this.IpsStatus = geoStatus;
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
      //this.outIpsStatus.emit(this.IpsStatus);  // send to parent page

      // if (this.content) { this.content.resize(); }
    });
  }

  public RefreshIpsStatus()
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mystatus.RefreshIpsStatus" + ' - Page:' + this.pageName, this.IpsStatus);
    this.zone.run(() => {
      this.IpsStatus = this.geolocationProvider.GetIpsStatus();
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
      //this.outIpsStatus.emit(this.IpsStatus);  // send to parent page

      // if (this.content) { this.content.resize(); }
    });
  }

  public RefreshIpsPosition()  // onIpsResponse(geoPosition:GeoPosition)
  {
    // allow parent page to force an inquiry, say on its page initialization
    if (this.consoleLog) console.log("mystatus.RefreshIpsPosition" + ' - Page:' + this.pageName);
    this.zone.run(() => {
      this.isIpsWatching = this.geolocationProvider.isIpsWatching();
      this.IpsPosition = this.geolocationProvider.GetIpsPosition();
      //this.outIpsPosition.emit(this.IpsPosition);  // send to parent page
      this.IpsStatus = this.geolocationProvider.GetIpsStatus();
      //this.outIpsStatus.emit(this.IpsStatus);  // send to parent page
      // if (this.content) { this.content.resize(); }
    });
  }

  // ----------------------------------------------------
  // --------- MAP OVERRIDE CONTROLLER WATCH ----------
  // ----------------------------------------------------

  public OverrideDisplayGpsStatus()// used by map 
  {
    this.zone.run(() => {
      // if the status is already on due to settings, then allow this to turn it off
      if (this.globalProvider.HeaderDisplay.GpsStatusFlag) // (this.isDisplayGpsStatus === true)
      {
        this.globalProvider.HeaderDisplay.GpsStatusFlag = false;
        if (this.consoleLog) console.log("mystatus.OverrideDisplayGpsStatus (Display Setting)", this.globalProvider.HeaderDisplay.GpsStatusFlag);
      }
      else 
      {
        this.isMapGpsOverride = !this.isMapGpsOverride;
        if (this.consoleLog) console.log("mystatus.OverrideDisplayGpsStatus (Map Override)", this.globalProvider.HeaderDisplay.GpsStatusFlag);
      }

      // if (this.content) { this.content.resize(); }
    });
  }

  public OverrideDisplayIpsStatus() // used by map 
  {
     this.zone.run(() => {
       // if the status is already on due to settings, then allow this to turn it off
       if (this.globalProvider.HeaderDisplay.IpsStatusFlag) // (this.isDisplayIpsStatus === true)
       {
         this.globalProvider.HeaderDisplay.IpsStatusFlag = false;
         if (this.consoleLog) console.log("mystatus.OverrideDisplayIpsStatus (Display Setting)", this.globalProvider.HeaderDisplay.IpsStatusFlag);
       }
       else
       {
         this.isMapIpsOverride = !this.isMapIpsOverride;
         if (this.consoleLog) console.log("mystatus.OverrideDisplayIpsStatus", this.globalProvider.HeaderDisplay.IpsStatusFlag);
       }

       // if (this.content) { this.content.resize(); }
     });
  }

  // ----------------------------------------------------
  // --------------- MONITOR SESSION WATCH --------------
  // ----------------------------------------------------
  SubscribeToMonitoring(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.Monitor: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    this.isSubscribeMonitoring = isSubscribe;
    if (isSubscribe)
    {
      this.zone.run(() => {
        this.isMonitoring = this.monitoringProvider.IsMonitoring();  // get initial state
        this.MobileMonitorUpdatesCount = this.monitoringProvider.GetMobileMonitorUpdatesCount();
        this.MonitorStatus = this.monitoringProvider.GetMonitorStatus();
        // if (this.content) { this.content.resize(); }
        if (this.consoleLog) console.log("mystatus.Monitor: - Page:" + this.pageName 
                  + " - isMonitoring:" + this.isMonitoring
                  + " - MonitorStatus:" + this.MonitorStatus
                  );
      });
      
      //this.ActiveStateMonitorTypeCode = this.monitoringProvider.GetActiveStateMonitorTypeCode();
      //this.MonitorSession = this.monitoringProvider.GetMonitorSession();
      //this.SetMonitorOccurred(this.isMonitoring);
      //this.outMonitorSession.emit(this.MonitorSession);  // send to parent page
      


      if ((!this.monitoringProvider) || (!this.monitoringProvider.monitoring))
      {
        console.warn("mystatus.Monitor: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName
                    + " MONITORING not defined yet");
        return;
      }

      this.monitoringSubscription = this.monitoringProvider.monitoring.subscribe(
        (isMonitoring) => { this.onMonitoringResponse(isMonitoring); }
      );
    }
    else
    {
      //if (this.consoleLog) console.log("mystatus.Monitoring UNSUBSCRIBE");
      if ((!this.monitoringProvider) || (!this.monitoringProvider.monitoring))
      {
        console.warn("mystatus.Monitor: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName
                    + " MONITORING not defined yet");
        return;
      }

      if (this.monitoringSubscription) this.monitoringSubscription.unsubscribe();
    }
  }

  onMonitoringResponse(isMonitoring:boolean)
  {
    // THIS SEEMS TO ONLY BE CALLED AT START/END OF MONITOR SESSION -- 

    if (this.consoleLog) console.log("mystatus.onMonitoringResponse - Page:" + this.pageName, isMonitoring);
    this.zone.run(() => {
      this.isMonitoring = isMonitoring;
      this.MonitorStatus = this.monitoringProvider.GetMonitorStatus();
      // if (this.content) { this.content.resize(); }
    });
  }

  public RefreshMonitoringStatus()
  {
    // allow parent page to force an inquiry that may have been caused by it
    // e.g. the Monitor page starts a session

    if (this.consoleLog) console.log("mystatus.refreshMonitoringStatus - Page:" + this.pageName);
    this.zone.run(() => {
      this.isMonitoring = this.monitoringProvider.IsMonitoring(); // isMonitoring;
      this.MonitorStatus = this.monitoringProvider.GetMonitorStatus();
      // if (this.content) { this.content.resize(); }
    });
  }

  // ----------------------------------------------------
  // ------------- MONITOR COUNTDOWN WATCH --------------
  // ----------------------------------------------------
  /*
  SubscribeToMonitorCountdown(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.MonitorCountdown: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    if (isSubscribe)
    {
      this.isMonitorTimerOn = this.monitoringProvider.IsMonitorTimerOn();  // get initial state
      //this.MonitorCountdownCurrent = this.monitoringProvider.GetMonitorCountdownCurrent();

      if (this.consoleLog) console.log("mystatus.MonitorCountdown SUBSCRIBE" + ' - Page:' + this.pageName);
      this.monitorCountdownSubscription = this.monitoringProvider.monitorTimer.subscribe(
        (isMonitorTimerOn, countdownCurrent) => { this.onMonitorCountdownResponse(isMonitorTimerOn, countdownCurrent); }
      );
    }
    else
    {
      if (this.consoleLog) console.log("mystatus.MonitorCountdown UNSUBSCRIBE" + ' - Page:' + this.pageName);
      this.monitorCountdownSubscription.unsubscribe();
    }
  }

  onMonitorCountdownResponse(isMonitorTimerOn:boolean, MonitorCountdownCurrent:number)
  {
    if (this.consoleLog) console.log("mystatus.onMonitorCountdownResponse - Page:" + this.pageName, isMonitorTimerOn);
    this.zone.run(() => {
      this.isMonitorTimerOn = isMonitorTimerOn;
      this.MonitorCountdownCurrent = MonitorCountdownCurrent; // doesn't seem to be returning anything
      this.MonitorCountdownCurrent = this.monitoringProvider.GetMonitorCountdownCurrent();
      this.MonitorStatus = this.monitoringProvider.GetMonitorStatus(); // includes countdown indication      
      this.MobileMonitorUpdatesCount = this.monitoringProvider.GetMobileMonitorUpdatesCount();
    });
  }
  */


  // ----------------------------------------------------
  // ------------- MONITOR COUNTDOWN WATCH --------------
  // ----------------------------------------------------

  // https://forum.ionicframework.com/t/events-pub-sub-how-to-unsubscribe-in-lifecycle-hook/50596/5?u=xme
  private _MonitorCountdownEventSub: (monitorCountdown:number) => void;

  DefineMonitorCountdownEventSub()
  {
    // NOTE!  remember to call this just before subscribing to the event
    if (this.consoleLog) console.log("mystatus.DefineMonitorCountdownEventSub" + ' - Page:' + this.pageName);
    this._MonitorCountdownEventSub = (monitorCountdown:number) => {
      this.onMonitorCountdown(monitorCountdown);
    };
  }

  public isActiveSubscriptionMonitorCountdown:boolean = false;
  SubscribeToMonitorCountdown(isSubscribe:boolean)
  {   
    if (this.consoleLog) console.log("mystatus.MonitorCountdown: " + (isSubscribe ? "SUBSCRIBE" : "UNSUBSCRIBE") + ' - Page:' + this.pageName);

    this.isMonitorTimerOn = this.monitoringProvider.IsMonitorTimerOn();  // get initial state
    this.isSubscribeMonitorCountdown = isSubscribe;
    if (isSubscribe)
    {
      if (this.isActiveSubscriptionMonitorCountdown === true)
      {
        if (this.consoleLog) console.log("mystatus.MonitorCountdown - ALREADY ACTIVE");
        return;
      }
      this.isActiveSubscriptionMonitorCountdown = true;
      this.DefineMonitorCountdownEventSub();
      this.events.subscribe('mystatus' + this.pageName, 'monitorCountdown', this._MonitorCountdownEventSub); 
    }
    else
    {
      if (this.consoleLog) console.log("mystatus.MonitorCountdown: ATTEMPT UNSUBSCRIBE" + ' - Page:' + this.pageName);
      this.events.unsubscribe('mystatus' + this.pageName, 'monitorCountdown', this._MonitorCountdownEventSub); 
      this.isActiveSubscriptionMonitorCountdown = false;
    }
  }

  onMonitorCountdown(monitorCountdown:number)
  {
    if (this.consoleLog) console.log("mystatus.onMonitorCountdown" + ' - Page:' + this.pageName, monitorCountdown);
    this.zone.run(() => {
      this.MonitorCountdownCurrent = monitorCountdown;
      this.MonitorCountdownCurrent = this.monitoringProvider.GetMonitorCountdownCurrent();
      this.isMonitorTimerOn = this.monitoringProvider.IsMonitorTimerOn(); // isMonitorTimerOn;
      this.MonitorStatus = this.monitoringProvider.GetMonitorStatus(); // includes countdown indication      
      this.MobileMonitorUpdatesCount = this.monitoringProvider.GetMobileMonitorUpdatesCount();

      this.isMonitoring = this.monitoringProvider.IsMonitoring();
    });
  }
  
}
